import { AuditLog } from '@/models/logs/AuditLog';
import moment from 'moment/moment';
import { AuditLogsTier1, AuditLogsTier2, AuditLogsTier3 } from '@/enums/AuditLogs';

export const _normalizeKeys = (obj: Record<string, any>) => {
  const result: Record<string, any> = {};

  for (const [key, value] of Object.entries(obj)) {
    const [baseKey, subKey] = key.split(".");

    if (!subKey) {
      result[baseKey] = value;
    } else {
      if (!result[baseKey]) {
        result[baseKey] = { after: {} };
      }
      if (!result[baseKey].after) {
        result[baseKey].after = {};
      }

      const cleanSubKey = subKey.replace(/^_/, "");
      result[baseKey].after[cleanSubKey] = value.after;
    }
  }

  return result;
}

export const _filterLogs = (logs: AuditLog[]) => {
  return logs
    .filter(log => Array.isArray(log.typesOfRecordChanged) && log.typesOfRecordChanged.length > 0)
    .filter(log => {
      if (!log.changedFields) return true;

      /*if (log.collection === "familyHubUsers") {
        const validKeys = Object.keys(log.changedFields).filter(key => !/\[[^\]]+\]/.test(key));
        return validKeys.length > 0;
      }*/

      return true;
    });
}

export const _filterFields = (log: AuditLog) => {
  let changedFields: any = log.changedFields ?? {};

  if (log.collection === "residents" && log.typesOfRecordChanged[0] === `${AuditLogsTier1.Residents}: ${AuditLogsTier2.Resident}: ${AuditLogsTier3.Amend}`) {
    changedFields = Object.fromEntries(Object.entries(changedFields).filter(([key]) => !key.startsWith("familyHubUsers")));

    if (changedFields?.accessesOnMyhub) {
      const before = changedFields.accessesOnMyhub.before.filter(x => changedFields.accessesOnMyhub.after.find(y => y.name === x.name).isEnabled !== x.isEnabled);
      const after = changedFields.accessesOnMyhub.after.filter(x => before.find(y => y.name === x.name));
      changedFields.accessesOnMyhub = { before: before, after: after };
    }
  }

  if(log.collection === "serviceRequests") {
    if(log?.data?.residentName) {
      changedFields.residentName = { after: log?.data?.residentName };
    }
  }

  return changedFields;
};

export const _formatLog = (log: AuditLog, initiators: any[], docs: any[]) => {
  const { seconds } = log.timestamp as { seconds: number; nanoseconds: number };
  const extractType = log.typesOfRecordChanged.map(item => item.split(":")[0].trim());
  const filteredFields = _filterFields(log);

  const changedFields: any = {
    id: { after: log?.docId ?? log?.data?.id },
    name: { after: log?.data?.name ?? log?.data?.title ?? log?.data?.serviceName },
    email: { after: log?.data?.email },
    ..._normalizeKeys(filteredFields ?? {})
  };

  return {
    ...log,
    timestamp: moment(seconds * 1000).toDate(),
    initiatorName: initiators.find(x => x.id === log.initiatorId)?.name ?? "",
    docName: docs.find(x => x.id === log.docId)?.name ?? "",
    types: extractType,
    changedFields
  };
}

export const _getInitiatorCollection = (type: string | null) => {
  switch (type) {
    case 'staff': return 'users';
    case 'familyMember': return 'familyHubUsers';
    case 'family': return 'familyHubUsers';
    case 'resident': return 'residents';
    default: return 'users';
  }
};